import { RouteObject } from 'react-router-dom';
import { Page404 } from 'src/error-page';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

const UserNotificationsList = lazyConReintento(() => import('./user-notifications-list'));
const UserNotificationDetails = lazyConReintento(() => import('./user-notification-details'));

const notificationsRoutes: RouteObject[] = [
  {
    path: 'notifications',
    element: diferida(<UserNotificationsList />)
  },
  {
    path: 'notifications/:notificationId',
    element: diferida(<UserNotificationDetails />)
  },
  {
    path: '*',
    element: <Page404 />
  }
];

export default notificationsRoutes;
